<!-->┌────┬─────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│ PA │                                   Login                                         │<- ->
<- ->└────┴─────────────────────────────────────────────────────────────────────────────────┘<--->

<style lang="less" src=":/PA/styles/ff_dashboard/login.less"></style>

<script>
    import Login from "@/pages/ff_dashboard/login"
    import conflicts from ":/PA/common/conflicts"

    export default {
        name: "Login",
        components: { conflicts },
        mixins: [Login]
    }
</script>
